'use strict';

export const CLASS_NAME = 'TeamTypeDomain';
export const COLLECTION = 'team-types';

export function TeamTypeDomainProvider() {
  return {
    $get: ['FirebaseUtil', 'AbstractDomainClass', 'OrgMixin',
      function (FirebaseUtil, AbstractDomainClass, OrgMixin) {
        //console.log('Created  TeamTypeDomain');

        function TeamTypeDomain(data) {
          AbstractDomainClass.call(this, TeamTypeDomain, data);
        }

        AbstractDomainClass.__inheritFrom(TeamTypeDomain, CLASS_NAME, COLLECTION);

        TeamTypeDomain.$constraints.addConstraints({
          name: {type: 'string'},
          namePlural: {type: 'string'},
          description: {type: 'string', widget: 'textarea', nullable: true},
          organization: {type: 'Domain', domainClass: 'OrganizationDomain'},
          createdBy: {type: 'DomainLink', domainClass: 'UserDomain'},
          dateCreated: {type: 'Date'},
          lastUpdated: {type: 'Date'},

          teams: {type: 'DomainCollection', domainClass: 'TeamDomain', link: 'type', relationClass: 'TeamRoleDomain'}
        });

        OrgMixin(TeamTypeDomain);

        // more methods go here;

        TeamTypeDomain.prototype.toString = function () {
          return this.name;
        };

        return TeamTypeDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/personnel/domain/TeamTypeDomain.js